import MapPoligonDrawing from './MapPoligonDrawing'

export default MapPoligonDrawing;
